import styled from "styled-components";

export const FormContainer = styled.div`
  max-width: 800px;
  margin: 0;
`;


export const FormSection = styled.div`
  padding: 0;

  form {
    .row {
      margin-bottom: 24px;
    }
  }
`;
